import httpClient from '../utils/axios'
import {
    handleServiceError,
    handleServiceResponse,
} from '../utils/serviceResponseHelper'

async function getAllServiceNames() {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/services`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

async function getService(processEngineServiceId) {
    try {
        const response = await httpClient.get(
            `${window.config.SERVICE_MANAGEMENT_API_URL}/service/${processEngineServiceId}`
        )
        return handleServiceResponse(response)
    } catch (error) {
        return await handleServiceError(error)
    }
}

export default {
    getAllServiceNames,
    getService,
}
